import styles from "./Cart.module.css";
import { useTranslation } from "react-i18next";
import { Trash2 } from "lucide-react";
import SecondaryButton from "../Button/SecondaryButton/SecondaryButton";
import SubmitButton from "../Button/SubmitButton/SubmitButton";

type CartSummaryActionsProps = {
    className: string;
    onDropCart: () => void;
    onCheckout: () => void;
    disabled: boolean;
};

const CartSummaryActions = ({
    className,
    onDropCart,
    onCheckout,
    disabled,
}: CartSummaryActionsProps) => {
    const { t } = useTranslation();

    return (
        <div className={className}>
            <SecondaryButton
                text={t("buttons.dropcart")}
                showChevron={false}
                colorVariant="primary"
                onClick={onDropCart}
                Icon={Trash2}
                className={styles.DropButton}
            />
            <SubmitButton
                text={t("buttons.proceed_to_cart")}
                onClick={onCheckout}
                disabled={disabled}
            />
        </div>
    );
};

export default CartSummaryActions;
